import { useState } from "react";
import { Menu, MenuItem, ListItemIcon } from "../../../../components";
import { formatDate } from "../../../../utils";
import { format } from "date-fns";
import shortid from "shortid";
import HistoricoEnvios from "./historico-envios.component";

const MenuAddActions = ({
  anchorEl,
  setAnchorEl,
  destinatarios,
  rowCount,
  buscarDestinatarios,
}) => {
  const [openHistorico, setOpenHistorico] = useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";
  const destinatariosColunas = [
    {
      field: "dataEnvio",
      headerName: "Data Envio",
      flex: 400,
      valueGetter: (params) => {
        return format(formatDate.received(params.value), "dd/MM/yyyy HH:mm");
      },
    },
    {
      field: "pessoaId",
      headerName: "Pessoa",
      flex: 400,
      valueGetter: (params) => {
        return params.row.pessoa.nomeRazaoSocial;
      },
    },
  ];

  const handleAddActionsClose = () => {
    setAnchorEl(null);
  };

  const handleCloseHistoricoDialog = () => {
    setOpenHistorico(!openHistorico);
    handleAddActionsClose();
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        elevation={1}
        getContentAnchorEl={null}
        id={menuId}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        autoFocus={false}
        open={isMenuOpen}
        onClose={handleAddActionsClose}
        className="m-3"
      >
        {[
          <MenuItem
            className="mb-1"
            onClick={handleCloseHistoricoDialog}
            sx={{ height: 20, borderRadius: 5 }}
            key={shortid.generate()}
          >
            <ListItemIcon style={{ minWidth: 42 }}>
              <i
                className="ph ph-paper-plane-tilt"
                style={{ fontSize: 16 }}
              ></i>
            </ListItemIcon>
            <span style={{ fontSize: 12 }}>Histórico de Envios</span>
          </MenuItem>,
        ]}
      </Menu>
      <HistoricoEnvios
        destinatarios={destinatarios}
        destinatariosColunas={destinatariosColunas}
        openHistorico={openHistorico}
        handleCloseHistoricoDialog={handleCloseHistoricoDialog}
        buscarDestinatarios={buscarDestinatarios}
        rowCount={rowCount}
      />
    </>
  );
};

export default MenuAddActions;
